import { CHECK_SESSION_STATE } from './constants';


const {
    DISABLE_SESSION_STATE_VERIFICATION,
    CHECK_STATE_REQUESTS_MAX_INTERVAL,
    STATE_IFRAME_RESPONSE_TIME_LIMIT,
    LOAD_STATE_IFRAME_TIME_LIMIT
} = CHECK_SESSION_STATE;



export class SessionStateHandler {
    constructor({ sessionStateHandlerCB = () => null, clientCredentials = {}, service } = {}) {
        this._iframeIsReady = false;
        this._loadingIframe = false;
        this._nextRequestSafetyNet = CHECK_STATE_REQUESTS_MAX_INTERVAL;
        this._loadStateIframeTimeLimit = LOAD_STATE_IFRAME_TIME_LIMIT;
        this._stateIframeResponseTimeLimit = STATE_IFRAME_RESPONSE_TIME_LIMIT;
        
        this._handleSessionStateCB = sessionStateHandlerCB;
        this._clientId = clientCredentials['client_id'];
        this._sessionState = '';
        this._service = service;
        this._handleSessionState = evt => this.handleSessionState(evt);
        this._disableSessionStateVerification = DISABLE_SESSION_STATE_VERIFICATION;
        return this;
    }

    createStateIframe() {
        if (this._loadingIframe) {
            return this;
        };

        this._loadingIframe = true;
        
        this._service.fetchStateIframeURL()
            .then(({ body }) => this.buildIframe(body))
            .catch(err => console.error(err));
        return this;
    }

    buildIframe({ check_session_iframe }) {
        const iframe = this._service.createStateIframe(check_session_iframe);
        const onload = () => {
            clearTimeout(this._iframeLoadTimeout);
            delete this._iframeLoadTimeout;
            this._iframeIsReady = true;
            this.sendMessage();
        };

        this._stateIframeHost = (new URL(check_session_iframe)).origin;
        
        document.body.appendChild(iframe);
        window.addEventListener("message", this._handleSessionState, false);

        iframe.onload = onload;

        this._iframeLoadTimeout = setTimeout(onload, this._loadStateIframeTimeLimit);
        this._stateIframe = iframe;
        return this;
    }

    handleSessionState(evt = { data: '{}', origin: '' }) {
        const origin = evt.origin;

        if (!origin || this._stateIframeHost !== origin) {
            return;
        };

        clearTimeout(this._responseTimeout);
        delete this._responseTimeout;

        const { status, sign } = JSON.parse(evt.data);

        if (!status || !sign || this._sign !== sign) {
            return;
        };

        return this._handleSessionStateCB(status === 'unchanged');
    }

    checkState(sessionsCredentials) {
        if (DISABLE_SESSION_STATE_VERIFICATION) {
            this._handleSessionStateCB(true);
            return this;
        };

        this._sessionState = sessionsCredentials['session_state'];

        if (!this._iframeIsReady) {
            this.createStateIframe();
            return this;
        };

        if (!this._lastRequest) {
            this.sendMessage();
            return this;
        };

        const pastTime = Date.now() - this._lastRequest;

        if (pastTime >= this._nextRequestSafetyNet) {
            this.sendMessage();
        };

        this._handleSessionStateCB(true);
        return this;
    }

    sendMessage() {
        
        this._sign = Math.random().toString(36).substring(2);
        this._lastRequest = Date.now();

        try {
            this._stateIframe.contentWindow.postMessage(JSON.stringify({
                sign: this._sign,
                message: `${this._clientId} ${this._sessionState}`
            }), this._stateIframeHost);

            this._responseTimeout = setTimeout(() => {
                this.handleSessionState({
                    data: '{"sign": "' + this._sign + '", "status": "unchanged"}',
                    origin: this._stateIframeHost
                });

                console.warn('Check user state timeout');
            }, this._stateIframeResponseTimeLimit);
        } catch (error) {
            console.error(error);
        };
    }

    close() {
        delete this._iframeIsReady;
        delete this._loadingIframe;
        delete this._nextRequestSafetyNet;
        delete this._loadStateIframeTimeLimit;
        delete this._stateIframeResponseTimeLimit;
        
        delete this._service;
        delete this._clientId;
        delete this._sessionState;
        delete this._handleSessionState;
        delete this._handleSessionStateCB;
        delete this._disableSessionStateVerification;
        return this;
    }
};